import { useCallback, useState } from 'react'

const useSessionChangePrice = () => {
  const [edit, setEdit] = useState({})
  const [prices, setPrices] = useState({})

  const initChangePrice = useCallback((cars, requiredGroups = []) => {
    const groups = [0].concat(requiredGroups.filter((group) => group))

    setEdit((s) => ({
      ...s,
      ...cars.reduce(
        (previous, car) => ({ ...previous, [car.plate]: false }),
        {}
      ),
    }))

    setPrices((s) => ({
      ...s,
      ...cars.reduce(
        (previous, car) => ({
          ...previous,
          [car.plate]: car.prices.map((price, i) => ({
            group: i,
            price: price,
            startingPrice: price,
            edited: false,
            edit: false,
            required: groups.includes(i),
          })),
        }),
        {}
      ),
    }))
  }, [])

  const getFormattedPrices = useCallback(
    (plate) => {
      const _prices = []

      for (let i = 0; i < prices[plate].length; i++) {
        _prices[prices[plate][i].group] = prices[plate][i].price
      }

      return _prices
    },
    [prices]
  )

  const toggleChangePrice = useCallback(
    (plate, callback) => {
      const _edit = !edit[plate]

      setEdit((s) => {
        return {
          ...s,
          [plate]: !s[plate],
        }
      })

      !_edit &&
        prices[plate].some((price) => price.edited) &&
        callback &&
        callback(plate, getFormattedPrices(plate))
    },
    [edit, getFormattedPrices, prices]
  )

  const toggleEditGroupPrice = useCallback(
    (plate, group) => {
      if (!edit[plate]) {
        return
      }
      const _prices = [...prices[plate]]
      const _price = _prices.find((price) => price.group === group)

      _price.edit = !_price.edit
      setPrices((s) => {
        return {
          ...s,
          [plate]: _prices,
        }
      })
    },
    [edit, prices]
  )

  const setGroupPrice = useCallback(
    (plate, group, value) => {
      const _prices = [...prices[plate]]
      const _price = _prices.find((price) => price.group === group)
      if (_price.price === value) {
        return
      }

      _price.edited = value ? true : _price.edited
      _price.price = value ? value : _price.price

      // eslint-disable-next-line sonarjs/no-identical-functions
      setPrices((s) => {
        return {
          ...s,
          [plate]: _prices,
        }
      })
    },
    [prices]
  )

  return {
    edit,
    prices,
    initChangePrice,
    toggleChangePrice,
    toggleEditGroupPrice,
    setGroupPrice,
  }
}

export default useSessionChangePrice
